<template>
  <v-row dense>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="text-h6">
            {{ $t('header') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('scaleSheetProfileHeaderTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.delimiter"
        :rules="[rules.required]"
        :label="$t('delimiter')"
        outlined
        maxLength="1"
        counter="1"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-row dense align="center">
        <v-col cols="auto">
          <v-switch
            v-model="useVirtualPrefix"
            :label="$t('useVirtualPrefix')"
            color="primary"
            class="mt-1"
          />
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('virtualPrefixTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="useVirtualPrefix" cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.virtualPrefix"
        :rules="[rules.required]"
        :label="$t('virtualPrefix')"
        outlined
        maxLength="1"
        counter="1"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.headerPrefix"
        :rules="literalPrefixRules"
        :disabled="useVirtualPrefix"
        :label="$t('headerPrefix')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.ticketNumberIndex"
        :rules="[rules.positiveInteger, rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('ticketNumberIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.settingIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('settingIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.tractIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('tractIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.destinationIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('destinationIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.contractAccountIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('contractAccountIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.productIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('productIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.weighedOutAtIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('weighedOutAtIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.inWeightIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('inWeightIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.outWeightIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('outWeightIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.netWeightIndex"
        :rules="[rules.positiveInteger, rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('netWeightIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.trailerIdentifierIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('trailerIdentifierIndex')"
        outlined
        maxLength="4"
        counter="4"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="text-h6">
            {{ $t('log') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('scaleSheetProfileLogTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.logPrefix"
        :rules="literalPrefixRules"
        :disabled="useVirtualPrefix"
        :label="$t('logPrefix')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.speciesIndex"
        :rules="[rules.positiveInteger, rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('speciesIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.buttLogIndex"
        :rules="[rules.positiveInteger, rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('buttLogIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentOne') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentOneInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneGradeIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('segmentOneGradeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneEndUseSortIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('segmentOneEndUseSortIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneLengthIndex"
        :rules="[rules.positiveInteger, rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('segmentOneLengthIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneDiameterIndex"
        :rules="[rules.positiveInteger, rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('segmentOneDiameterIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneGrossVolumeIndex"
        :rules="segmentOneVolumeRules"
        :label="$t('segmentOneGrossVolumeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneNetVolumeIndex"
        :rules="segmentOneVolumeRules"
        :label="$t('segmentOneNetVolumeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneDefectVolumeIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('segmentOneDefectVolumeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentTwo') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentTwoInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoGradeIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('segmentTwoGradeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoEndUseSortIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('segmentTwoEndUseSortIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoLengthIndex"
        :rules="segmentTwoRules"
        :label="$t('segmentTwoLengthIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoDiameterIndex"
        :rules="segmentTwoRules"
        :label="$t('segmentTwoDiameterIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoGrossVolumeIndex"
        :rules="segmentTwoVolumeRules"
        :label="$t('segmentTwoGrossVolumeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoNetVolumeIndex"
        :rules="segmentTwoVolumeRules"
        :label="$t('segmentTwoNetVolumeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoDefectVolumeIndex"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_INDEX)]"
        :label="$t('segmentTwoDefectVolumeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentThree') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentThreeInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeLengthIndex"
        :rules="segmentThreeRules"
        :label="$t('segmentThreeLengthIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeDiameterIndex"
        :rules="segmentThreeRules"
        :label="$t('segmentThreeDiameterIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeGrossVolumeIndex"
        :rules="segmentThreeVolumeRules"
        :label="$t('segmentThreeGrossVolumeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeNetVolumeIndex"
        :rules="segmentThreeVolumeRules"
        :label="$t('segmentThreeNetVolumeIndex')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
  </v-row>
</template>

<script>
import fieldRules from '@/utils/rules.js'
export default {
  name: 'ScaleSheetImportDelimitedProfileForm',

  props: {
    propProfile: {
      type: Object,
      required: true
    }
  },

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  data: () => ({
    rules: fieldRules.rules,
    useVirtualPrefix: false
  }),

  created () {
    this.useVirtualPrefix = !!this.propProfile.virtualPrefix
  },

  watch: {
    useVirtualPrefix (enabled) {
      if (enabled) {
        this.profile.headerPrefix = null
        this.profile.logPrefix = null
      } else {
        this.profile.virtualPrefix = null
      }
    }
  },

  computed: {
    constants () {
      return {
        MAX_INDEX: 1000
      }
    },
    profile: {
      get () {
        return this.propProfile
      },
      set (value) {
        this.$emit('update', value)
      }
    },
    literalPrefixRules () {
      return this.useVirtualPrefix ? [] : [this.rules.required]
    },
    segmentOneVolumeRules () {
      if (this.propProfile.segmentOneDiameterIndex &&
      this.propProfile.segmentOneLengthIndex &&
      !this.propProfile.segmentOneGrossVolumeIndex &&
      !this.propProfile.segmentOneNetVolumeIndex
      ) {
        return [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
      }
      return [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
    },
    segmentTwoRules () {
      return this.propProfile.segmentTwoDiameterIndex ||
        this.propProfile.segmentTwoLengthIndex ||
        this.propProfile.segmentTwoGrossVolumeIndex ||
        this.propProfile.segmentTwoNetVolumeIndex
        ? [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
        : [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
    },
    segmentTwoVolumeRules () {
      if (this.propProfile.segmentTwoDiameterIndex &&
      this.propProfile.segmentTwoLengthIndex &&
      !this.propProfile.segmentTwoGrossVolumeIndex &&
      !this.propProfile.segmentTwoNetVolumeIndex
      ) {
        return [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
      }
      return [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
    },
    segmentThreeRules () {
      return this.propProfile.segmentThreeDiameterIndex ||
        this.propProfile.segmentThreeLengthIndex ||
        this.propProfile.segmentThreeGrossVolumeIndex ||
        this.propProfile.segmentThreeNetVolumeIndex
        ? [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
        : [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
    },
    segmentThreeVolumeRules () {
      if (this.propProfile.segmentThreeDiameterIndex &&
      this.propProfile.segmentThreeLengthIndex &&
      !this.propProfile.segmentThreeGrossVolumeIndex &&
      !this.propProfile.segmentThreeNetVolumeIndex
      ) {
        return [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
      }
      return [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_INDEX)]
    }
  }
}
</script>
